import { useEffect } from "react";
import useToggle from "../useToggle";
/**
 * A small hook for checking if the app is currently being interacted with by a
 * keyboard.
 *
 * @return true if the app is in keyboard mode
 * @private
 */
export default function useKeyboardDetection() {
    var _a = useToggle(false), enabled = _a[0], enable = _a[1], disable = _a[2];
    useEffect(function () {
        if (enabled) {
            return;
        }
        window.addEventListener("keydown", enable, true);
        return function () {
            window.removeEventListener("keydown", enable, true);
        };
    }, [enabled, enable]);
    useEffect(function () {
        if (!enabled) {
            return;
        }
        window.addEventListener("mousedown", disable, true);
        window.addEventListener("touchstart", disable, true);
        return function () {
            window.removeEventListener("mousedown", disable, true);
            window.removeEventListener("touchstart", disable, true);
        };
    }, [enabled, disable]);
    return enabled;
}
//# sourceMappingURL=useKeyboardDetection.js.map